<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" size="small" label-width="140px" :rules="rules" ref="form">
      <el-form-item label="应用名称" prop="app_store_id">
        <el-select v-model="form.app_store_id" filterable @change="appChange">
          <el-option v-for="item in dialogData.appList" :key="item.id" :value="item.id" :label="`${item.name}(${item.code})`">
            <span style="float: left;font-size: 13px">{{ `${item.name}(${item.code})` }}</span>
            <span style="float: right;font-size: 12px;color: #8492a6;">{{ `1个/1${appPeriodObj[item.period]}/${convertYuan(item.price)}元` }}</span>
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="应用数量" prop="quantity" v-if="currentApp.with_qty">
        <el-input-number v-model="form.quantity" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item :label="currentApp.period ? `应用有效时长(${appPeriodObj[currentApp.period]})` : `应用有效时长`" prop="duration">
        <el-input-number v-model="form.duration" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="代金券数量" prop="count">
        <el-input-number v-model="form.count" :min="1"></el-input-number>
      </el-form-item>
      <el-form-item label="代金券有效期" prop="expire_at">
        <date-picker v-model="form.expire_at" dateType="datetime" type="after" :shortcuts="shortcuts"/>
      </el-form-item>
      <el-form-item label="代金券金额">
        <span class="color-primary" v-if="amount">{{convertYuan(amount)}}￥</span>
        <span v-else>-</span>
      </el-form-item>
      <el-form-item label="订单描述" prop="reason">
        <el-input v-model="form.reason" type="textarea" :rows="3" maxlength="128" show-word-limit resize="none" placeholder="描述订单原因或用途"></el-input>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
import {changeEmpty, inputEmpty} from '@utils/validate'
import DatePicker from "@view/components/date/DatePicker"
import {appPeriod,shortcuts} from "@utils/formatList";
export default {
  name: "TableOperate",
  props: {dialogData: Object},
  components: {DatePicker},
  data() {
    return {
      shortcuts,
      appPeriodObj: this.formatToObj(appPeriod),
      currentApp: {},
      form: {
        app_store_id: "",
        quantity: "",
        count: "",
        duration: "",
        expire_at: "",
        reason: "",
      },
      rules: {
        app_store_id: [changeEmpty("应用名称")],
        quantity: [inputEmpty("应用数量")],
        count: [inputEmpty("代金券数量")],
        duration: [inputEmpty("应用有效时长")],
        expire_at: [changeEmpty("代金券有效期")],
        reason: [inputEmpty("订单描述")],
      },
    }
  },
  computed: {
    amount() {
      return this.currentApp.price * this.form.quantity * this.form.duration * this.form.count
    },
  },
  created() {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 10);
    this.form.expire_at = this.getCurrentTime(null, date);
  },
  methods: {
    appChange(id) {
      this.currentApp = this.dialogData.appList.find(item => item.id === id) || {};
      this.form.quantity = 1;
    },
    confirm() {
      this.$refs["form"].validate(async isOk => {
        if (isOk) {
          const nv = {
            ...this.form,
            amount: this.amount,
          };
          const res = await this.$Http.createAppVoucher(nv);
          if (res) {
            this.$emit("getData")
            this.msgSuccess("下单成功");
            this.dialogData.visible = false;
          }
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">

</style>
